module.exports = __webpack_public_path__ + "img/wolf_2kl.e8928e18.jpg";